import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { montarAviso } from "./mensagens";
import CanceladoSefazBadge from "../cte/CanceladoSefazBadge";

// PO1-3414: o selo do cancelado aqui é de CT-e removido, não do preso em fatura.
const TITULO_CANCELADO_REMOVIDO =
  "A SEFAZ registrou o cancelamento deste CT-e e ele foi removido do Hub. Não pode ser faturado.";

// PO1-3409: substitui o "nenhum encontrado" de uma busca por identificador.
// Pergunta ao backend se o termo existe fora dos filtros da tela (dentro do
// escopo do usuário) e, se existir, diz onde está. Sem achado, mostra o
// `fallback` de sempre. Enquanto consulta, também mostra o fallback, para não
// piscar a tela.
//
// props:
//   tipo:     "cte" | "fatura"
//   tela:     "auditoria" | "integracao"
//   termo:    o que o usuário digitou
//   contexto: filtros da tela { embarcadorId, transportadoraId, dataInicial, dataFinal }
//   fallback: texto do vazio de sempre
//   acao:     opcional { rotulo, onClick } exibida junto do aviso
const ESPERA_MS = 400;

export default function AvisoForaDoFiltro({ tipo, tela, termo, contexto, fallback, acao }) {
  const [aviso, setAviso] = useState(null);
  const termoLimpo = String(termo || "").trim();
  const chaveContexto = JSON.stringify(contexto || {});

  useEffect(() => {
    setAviso(null);
    if (!termoLimpo || !tipo) return undefined;
    let cancelado = false;
    const timer = setTimeout(async () => {
      try {
        const ctx = JSON.parse(chaveContexto);
        const params = { tipo, termo: termoLimpo };
        Object.keys(ctx).forEach((k) => {
          if (ctx[k] !== null && ctx[k] !== undefined && ctx[k] !== "") params[k] = ctx[k];
        });
        const { data } = await api.get("/documentos/localizar", { params });
        if (cancelado) return;
        setAviso(montarAviso({ tipo, tela, termo: termoLimpo, achados: data && data.achados }));
      } catch (e) {
        // Falha na consulta extra não pode quebrar a tela: fica o vazio de sempre.
        if (!cancelado) setAviso(null);
      }
    }, ESPERA_MS);
    return () => {
      cancelado = true;
      clearTimeout(timer);
    };
  }, [tipo, tela, termoLimpo, chaveContexto]);

  if (!aviso) return <>{fallback}</>;

  return (
    <div
      role="status"
      style={{
        textAlign: "left",
        display: "inline-block",
        maxWidth: 760,
        padding: "0.75rem 1rem",
        borderRadius: 10,
        border: "1px solid color-mix(in srgb, var(--everlog-status-warning) 45%, transparent)",
        background: "color-mix(in srgb, var(--everlog-status-warning) 10%, transparent)",
        color: "inherit",
        lineHeight: 1.45,
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: "0.35rem", display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap" }}>
        {aviso.cancelado && <CanceladoSefazBadge compact title={TITULO_CANCELADO_REMOVIDO} />}
        <span>{aviso.titulo}</span>
      </div>
      <ul style={{ margin: 0, paddingLeft: "1.1rem" }}>
        {aviso.linhas.map((linha) => (
          <li key={linha}>{linha}</li>
        ))}
      </ul>
      {acao && acao.rotulo && typeof acao.onClick === "function" && (
        <button
          type="button"
          onClick={acao.onClick}
          className="btn btn-sm btn-outline-warning"
          style={{ marginTop: "0.6rem" }}
        >
          {acao.rotulo}
        </button>
      )}
    </div>
  );
}
